import { isNullOrEmpty } from '@/utils'
import { DashboardPanel } from '@/components/settings'
import { PadInfo, Contract } from '@/features/Pad'
import ConnectPad from './connect'
import EditPad from './edit'

type DashboardProps = {
  padContracts: Contract[]
  padInfo: PadInfo
}

const PadDashboardSummary: React.FC<DashboardProps> = ({ padContracts, padInfo }) => {
  const hasPadInfo = !isNullOrEmpty(padInfo)

  return (
    <DashboardPanel>
      {hasPadInfo ? <EditPad contracts={padContracts} accountData={padInfo} /> : <ConnectPad />}
    </DashboardPanel>
  )
}

export default PadDashboardSummary
